import tacklebox from "tacklebox";

import { Page } from '@/js/Page.js';

function Category(id, title) {
    this.id = id;
    this.title = title;
}

function Keyword(raw) {
    this.raw = raw;
}
Keyword.prototype.getId = function () {
    if (this.raw?.id) {
        return this.raw?.id;
    }
    return "";
};
Keyword.prototype.getTitle = function () {
    if (this.raw?.title) {
        return this.raw?.title;
    }
    return "";
};

function HomePage() {
    Page.call(this, "home", "Home");
    this.categories = [];
    this.keywords = [];
}
tacklebox.design.extend(HomePage, Page);
HomePage.prototype._onInitialize = function () {
    const self = this;

    fetch(process.env.VUE_APP_HACHIWARE + "/lps/recommend")
        .then((response) => response.json())
        .then((json) => {
            if (json?.data) {
                for (let i in json.data) {
                    let e = json.data[i];
                    self.categories.push(new Category(e.id, e.title));
                }
            }
        })
        .catch((error) => {
            tacklebox.e(error)
        })
};

export { HomePage }
